import React from "react";
import ReactPaginate from "react-paginate";
export default function Pagination({ handlePageClick, pageCount }) {
  return (
    <div className="pagination" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={10}
        pageCount={pageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        containerClassName="pagination-list"
        pageClassName="pagination-page"
        pageLinkClassName="pagination-link"
        previousClassName="pagination-previous"
        nextClassName="pagination-next"
        breakClassName="pagination-break"
        activeClassName="pagination-active"
        disabledClassName="pagination-disabled"
      />
    </div>
  );
}
